import { Enviroment } from "../../../enviroments";
import { Api } from "../axios-config"
import CookieService from "../../autenticacao/CookieService";

export interface IDadosFreeAgency {
    codUsuCriacao?: number,
    franquia: IListagemTimes[],
    configuracao_Salario: IListagemSalarios[],
    lance_Free_Agency: IListaDadosLanceFreeAgency[]
}

export interface IDadosRetornoFreeAgencyRestrito {
    dado: IListaDadosLanceFreeAgency[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

type TFreeAgencyRestritoComTotalCount = {
    data: IDadosRetornoFreeAgencyRestrito;
    totalCount: number;
}


export interface IListaDadosLanceFreeAgency {
    codigo?: number;
    codigo_Franquia: number;
    codigo_Jogador: number;
    codigo_Free_Agency: number;
    valor: string;
    valor_Descontado_Restrito?: string;
    valor_Descontado_Direito?: string;
    tempo_Contrato: number;
    codUsuCriacao?: number;
    foto_Jogador: string;
    nome_Jogador: string;
    valor_Ultimo_Contrato_Jogador: string;
    franquia_Direitos_Jogador: string;
    codigo_Franquia_Direitos_Jogador: number;
    logo_Franquia_Direitos_Jogador: string;
    restrito_Jogador: boolean;
    draftado: boolean;
    posicao_Jogador_1: string;
    posicao_Jogador_2: string;
    posicao_Jogador_3: string;
    data_Fim_Lance: Date;
    data_Restante_Lance: string;    
    franquia_Lance_Jogador: string;
    logo_Franquia_Lance_Jogador: number;
    valor_Desconto: string;
    aprovacao_Restrito: boolean;
    vencedor: boolean;
    superada: boolean;
}

export interface IListagemTimes {
    codigo: number;
    nome: string;
    logo: string;
    nome_Logo: string;
    cap: string;
    valor_Total_Lance: string;
    quantidade_Lance: number;
    cap_Disponivel: number;
    quantidade_Slots: number;
    quantidade_Slots_Disponivel: number;

}


export interface IListagemSalarios {
    codigo: number;
    valor_Minimo: string;
    valor_Maximo: string;
    tempo_Minimo: string;
    tempo_Maximo: string;

}

export interface IDadosRetornoFreeAgency {
    dado: IDadosFreeAgency;
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}


type TFreeAgencyComTotalCount = {
    data: IDadosRetornoFreeAgency;
    totalCount: number;
}

export interface IDadosEstatisticas {
    codigo: number;
    codigo_NBA: number;
    nome: string;
    foto?: string;
    arremessos: number;
    lance_Livre: number;
    tres_Pontos: number;
    pontos: number;
    rebotes: number;
    rebotes_Ofensivos: number;
    rebotes_Defensivos: number;
    assistencias: number;
    steal: number;
    bloqueios: number;
    turnovers: number;
    faltas: number;
    minutos: number;
    min_Plus: number;
    quantidade_Jogos: number;
    porcentagem_Arremessos: number;
    porcentagem_Lance_Livre: number;
    porcentagem_Tres_Pontos: number;
    peso_Total_Jogador: number;
    arremessos_Tentativas: number;
    lance_Livre_Tentativas: number;
    tres_Pontos_Tentativas: number;
    lance_Livre_Errados?:number; 
    arremessos_Errados?:number;
    tres_Pontos_Errados?:number;
    stocks?:number;
}


export interface IDadosRetornoJogadoresEstatisticas {
    dado: IDadosEstatisticas[];
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

// export interface IDetalheJogadorFreeAgency {
//     codigo?: number;
//     codigo_Franquia: number;
//     codigo_Jogador: number;
//     codigo_Free_Agency: number;
//     valor: string;
//     tempo_Contrato: number;
//     codUsuCriacao?: number;

// }

export interface IDadosContratacaoFreeAgency {
    codigo: number;
    codigo_Franquia: number;
    codigo_Jogador: number;
    codigo_Free_Agency: number;
    codUsuCriacao: number;
}

export interface IListagemHistoricoLance {
    codigo: number;
    jogador: string;
    time: string;
    valor: string;
    periodo: string;
}

export interface IDadosRetornoHistoricoFreeAgency {
    dado: IListaDadosHistoricoFreeAgency[];
    numeroPagina: number;
    tamanhoPagina: number;
    totalPaginas: number;
    totalRegistros: number;
    statusHTTP: number;
    status: number;
}

export interface IListaDadosHistoricoFreeAgency {
    codigo?: number;
    codigo_Franquia: number;
    codigo_Jogador: number;
    codigo_Free_Agency: number;
    tempo_Contrato: number;
    vencedor: boolean;
    codigo_Franquia_Superada: number;
    aprovacao_Restrito: string;
    superada: boolean;
    dtCriacao: Date;
    codUsuCriacao: number;
    nome_Jogador: string;
    foto_Jogador: string;
    nome_Franquia: string;
    logo_Franquia: string;
    valor: string;
    data_Fim_Lance: Date;

}

export interface IDadosRetornoContratos {
    dado: any;
    erros: string;
    mensagem: string;
    processado: boolean;
    status: number;
    statusHTTP: number;
}

const getAllPorCodigo = async (codigoFreeAgency: number): Promise<TFreeAgencyComTotalCount> => {
    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/freeagency/completo/${codigoFreeAgency}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getAllRestritoPorCodigo = async (codigoFreeAgency: number, codigoFranquia: number): Promise<TFreeAgencyRestritoComTotalCount> => {
    const token = CookieService.get("access_token");
    const { data, headers } = await Api.get(`/freeagency/lance/restrito/${codigoFreeAgency}/${codigoFranquia}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getAllHistoricoLanca= async (codigoJogador: number, codigoLiga: number, codigoTemporada: number): Promise<TFreeAgencyRestritoComTotalCount> => {
    const token = CookieService.get("access_token");
     const user = CookieService.get("access_user");
    const { data, headers } = await Api.get(`/freeagency/historico/jogador/${codigoJogador}/${codigoLiga}/${codigoTemporada}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token,
            "codUsuario": user.codUsuario
        }
    });

    return {
        data,
        totalCount: Number(headers['x-total-count'] || Enviroment.LIMITE_DE_LINHAS),
    };
}

const getHistoricoFreeAgency = async (codigoFreeAgency: number): Promise<IDadosRetornoHistoricoFreeAgency> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.get(`/freeagency/historico/${codigoFreeAgency}`, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });

    return data;
}

const createContratarFreeAgency = async (dados: IDadosContratacaoFreeAgency): Promise<IDadosContratacaoFreeAgency> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.post(`/freeagency/restrito/lance`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const updateRecusarContratoFreeAgency = async (dados: IDadosContratacaoFreeAgency): Promise<IDadosContratacaoFreeAgency> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.put(`/freeagency/restrito/recusarlance`, dados, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const updateGerarContratosFreeAgency = async (): Promise<IDadosRetornoContratos> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.put(`/freeagency/lance/finalizar`,null, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}

const updateGerarContratoFreeAgency = async (codigoLance: number, codigoUsuario: number): Promise<IDadosRetornoContratos> => {
    const token = CookieService.get("access_token");
    const { data } = await Api.put(`/freeagency/lance/finalizar/${codigoLance}/${codigoUsuario}`,null, {
        headers: {
            "Access-Control-Allow-Origin": "*",
            "chavesessao": token
        }
    });
    return data;
}


export const FreeagencyService = {
    getAllPorCodigo,
    getAllRestritoPorCodigo,
    createContratarFreeAgency,
    updateRecusarContratoFreeAgency,
    getHistoricoFreeAgency,
    getAllHistoricoLanca,
    updateGerarContratosFreeAgency,
    updateGerarContratoFreeAgency
}